export default {
  label: {
    noLogoSelected: 'No logo selected',
    logoTitle: 'Header image link',
    colorTitle: 'Header color',
    themeTitle: 'Theme',
    clearColor: 'Clear color',
    themeSwitch: 'Dark theme',
  },
};
